import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Modelos
import { DevolucionDeDinero} from '../models/devolucionDeDinero';
// Environment Variables
import { environment } from '../../environments/environment';
// Angular Fire
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { EnviarCorreoService } from './enviar-correo.service';
import { Observable } from 'rxjs';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { interval } from 'rxjs/observable/interval';
import { merge } from 'rxjs/observable/merge';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/shareReplay';
import 'rxjs/add/operator/distinctUntilChanged';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class ConfirmacionesService {

  constructor(
    private http:HttpClient,
    private afs:AngularFirestore,
    private afDB:AngularFireDatabase,
  private enviarCorreoService:EnviarCorreoService) { }

    private solicitudesRefresh$ = new BehaviorSubject<void>(undefined);


  /**
   * Obtiene todas las confirmaciones
   */
  public obtenerTodasLasConfirmaciones(){
    return this.afs.collection('confirmaciones', ref => ref.orderBy('fechaDeConfirmacion','asc'));
  }
    public obtenerTodasLasConfirmacionesPorTabla(tabla){
        return this.afs.collection(tabla, ref => ref.orderBy('fechaDeConfirmacion','asc'));
    }
  public obtenerConfirmacionesEntreFechas(fehcaInicio, fechaFin){
    return this.afs.collection('confirmaciones', ref => ref.orderBy('fechaDeConfirmacion','asc').startAt(fehcaInicio).endAt(fechaFin));
  }

  public obtenerConfirmacionesPorFechaDeConfirmacion(fechaInicio: number, fechaFin: number) {
    return this.afs.collection('confirmaciones', ref => ref
      .orderBy('fechaDeConfirmacion', 'asc')
      .startAt(fechaInicio)
      .endAt(fechaFin)
    );
  }

  public obtenerConfirmacionesCanceladasEnRango(fechaInicio: number, fechaFin: number) {
    return this.afs.collection('confirmaciones', ref => ref
      .orderBy('fechaCancelacion', 'desc')
      .startAt(fechaFin)
      .endAt(fechaInicio)
    );
  }

  public getNegocioPorIdHubspot(dealId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
    const body = 'dealId=' + dealId;
    return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/getNegocioById.php', body, {headers});
  }

  public updateFechaFinHubspot(dealId: string, fechaInicio: string, fechaFin: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
    const body = 'dealId=' + dealId + '&fecha_de_viaje=' + fechaInicio + '&fecha_de_fin=' + fechaFin;
    return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/updateNegocioFechas.php', body, {headers});
  }

  public updatePrecioHubspot(dealId: string, precio: number) {
    const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
    const body = 'dealId=' + dealId + '&precio=' + precio;
    return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/updateNegocioPrecio.php', body, {headers});
  }

  /**
   * Obtiene una confirmación por ID
   * @param idConfirmacion
   */
  public obtenerConfirmacion(idConfirmacion:string){
    return this.afs.collection('confirmaciones').doc(idConfirmacion);
  }

  /**
   * Obtiene las confirmaciones por 1 cliente
   * @param idCliente
   */
  public obtenerConfirmacionesPorCliente(idCliente:string){
    return this.afs.collection('confirmaciones',ref => ref.where('cliente','==',idCliente));
  }

    public obtenerConfirmacionPorIDTrosten(idConfirmacion:string){
        return this.afs.collection('confirmaciones',ref => ref.where('idTrosten','==',idConfirmacion));
    }

    
    public obtenerConfirmacionPorKeyCotizacion(keyCotizacion:string){
      return this.afs.collection('confirmaciones',ref => ref.where('cotizacion','==',keyCotizacion));
  }

  /**
   * Obtiene las confirmaciones por 1 cliente entre fechas
   * @param idCliente
   */
  public obtenerConfirmacionesPorClienteEntreFechas(idCliente:string,fechaInicio,fechaFin){
    return this.afs.collection('confirmaciones',ref => ref
        .where('cliente','==',idCliente)
        .orderBy('fechaDeConfirmacion').startAt(fechaInicio).endAt(fechaFin)
    );
  }

  public cancelarRutaTurismoCorpSchool(id_confirmacion){
      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

      const body = 'id_confirmacion='+id_confirmacion;

      return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/cancelarRutaTuristica.php', body,{headers});
  }

  public actualizarUsosDescuentos (descuentoMarketing,descuentoAdmin,descuentoAdicional,usuario_uso, key,tipo,idTrosten)
  {
      var aux_adicional = {};
      if(descuentoAdicional.cantidad>0)
      {
          aux_adicional = descuentoAdicional;
      }
      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
      const body = 'descuentoMarketing=' + JSON.stringify(descuentoMarketing) +
          '&descuentoAdmin='+JSON.stringify(descuentoAdmin)+
          '&descuentoAdicional='+JSON.stringify(aux_adicional)+
          '&key='+key+
          '&cot_o_con='+tipo+
          '&usuario_uso='+usuario_uso+
          '&idTrosten='+idTrosten;

      return this.http.post('https://operacion.trosten.com/admin-exec/php/admin/Codigos_Descuento/actualizarUsosDescuentos.php', body,{headers});
  }

    public getNegociosPendientes()
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = '';

        return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/getNegociosPendientes.php', body,{headers});

    }

    public moverNegociosVencidos(arrayIdsNegociosVencidos)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'arrayIdsNegociosVencidos='+JSON.stringify(arrayIdsNegociosVencidos);

        return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/moverNegociosVencidos.php', body,{headers});
    }

    public editarIdNegocioHubspotConfirmacion(idConfirmacion:string,idNegocioHubSpot:string){
        return this.afs.collection('confirmaciones').doc(idConfirmacion).update({idNegocioHubSpot : idNegocioHubSpot});
    }

    public actualizarPuedeUsarOperadorExterno(idConfirmacion:string, nuevoValor:string){
        return this.afs.collection('confirmaciones').doc(idConfirmacion).update({puedeUsarOperadorExterno : nuevoValor});
    }

    public updateConfirmacionHubSpot(objInfoUpdateHubspot)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        var dealname = objInfoUpdateHubspot.idTrosten+ " / " + objInfoUpdateHubspot.nombreCliente;
        var fecha_de_viaje = objInfoUpdateHubspot.fechaInicio || '';
        var fecha_de_fin_del_viaje = objInfoUpdateHubspot.fechaFin || '';

        const enc = encodeURIComponent;
        var body = 'amount=' + enc(objInfoUpdateHubspot.total) +
            '&dealId='+enc(objInfoUpdateHubspot.idNegocioHubSpot)+
            '&alias_destino='+enc(objInfoUpdateHubspot.aliasDestino || '')+
            '&alias_origen='+enc(objInfoUpdateHubspot.aliasOrigen || '')+
            '&perfilCliente='+enc(objInfoUpdateHubspot.nombreCliente || '')+
            '&idConfirmacion='+enc(objInfoUpdateHubspot.idTrosten)+
            '&contratante='+enc(objInfoUpdateHubspot.nombreContratante || '')+
            '&fecha_de_viaje='+enc(fecha_de_viaje)+
            '&fecha_de_fin_del_viaje='+enc(fecha_de_fin_del_viaje)+
            '&dealname='+enc(dealname)+
            '&fecha_de_cotizacion='+enc(objInfoUpdateHubspot.fechaDeCotizacion || '')+
            '&fecha_de_confirmacion='+enc(objInfoUpdateHubspot.fechaDeConfirmacion || '');

        if (objInfoUpdateHubspot.moverACierreGanado) {
            body += '&dealstage=19311259&pipeline=6424872';
        }

        return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/updateNegocio.php', body,{headers});

    }
    
    public updateConfirmacionUltimaVezLeidaHubSpot(idNegocioHubspot)
    {
      var dateFinServicio = new Date()
      dateFinServicio.setHours(0);
      dateFinServicio.setMinutes(0)
      var finDeServicioFecha = (dateFinServicio).toISOString();
      var forcedMidnighFinDeServicioFecha = finDeServicioFecha.replace(finDeServicioFecha.substring(finDeServicioFecha.indexOf('T'), finDeServicioFecha.lastIndexOf(':00:')), 'T00');

      console.log("forcedMidnighFinDeServicioFecha", forcedMidnighFinDeServicioFecha)
      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
      const body = 'dealId='+idNegocioHubspot+
      '&fecha_leida='+forcedMidnighFinDeServicioFecha;
      return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/updateNegocioUltimaVezConfiLeido.php', body,{headers});
    }
    

     public updateNegocioTipoDeServicio(idNegocioHubspot,tipoDeServicio)
    {
      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
      const body = 'dealId='+idNegocioHubspot+
      '&tipo_de_servicio='+tipoDeServicio;
      return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/updateNegocioTipoServicio.php', body,{headers});
    }



    
    

    public crearRutaTurismoCorpSchool(cotizacion,serviciosConfirmados,id_confirmacion,idTrosten,idHubSpot,parejas,asignacionEspecial,puedeUsarOperadorExterno){

       var info_adicional = {
           conceptosAdicionales:"",
           notas:"",
           indicacionesEspeciales:"",
           notasOperaciones:"",
           unidadesSolicitadas:""
       }
       var origen = {
           alias:"",
           lat:"",
           lng:"",
           direccion:"",
           referencias:""
       }
       var destino = {
            alias:"",
            lat:"",
            lng:"",
            direccion:"",
           referencias:""
        }

        let puntos_intermedios = []

        let horaInicio = 0;
       let horaFin = 0;

       let series = [];

       let tipoDeViaje= ""

       let tipoUnidades = ""


       serviciosConfirmados.forEach(servicioConfirmado => {
           if(servicioConfirmado.servicio.hasOwnProperty('tipoDeViaje'))
               tipoDeViaje = servicioConfirmado.servicio.tipoDeViaje;

            if(servicioConfirmado.servicio.hasOwnProperty('conceptosAdicionales'))
                info_adicional.conceptosAdicionales = servicioConfirmado.servicio.conceptosAdicionales;
            if(servicioConfirmado.servicio.hasOwnProperty('notas'))
                info_adicional.notas = servicioConfirmado.servicio.notas;
            if(servicioConfirmado.servicio.hasOwnProperty('indicacionesEspeciales'))
                info_adicional.indicacionesEspeciales = servicioConfirmado.servicio.indicacionesEspeciales;
            if(servicioConfirmado.servicio.hasOwnProperty('notasOperaciones'))
                info_adicional.notasOperaciones = servicioConfirmado.servicio.notasOperaciones;
            if(servicioConfirmado.servicio.hasOwnProperty('puntosIntermedios'))
            {
                for (const key in servicioConfirmado.servicio.puntosIntermedios) {
                    if (servicioConfirmado.servicio.puntosIntermedios.hasOwnProperty(key)) {
                        const element = servicioConfirmado.servicio.puntosIntermedios[key];
                        element.id=key;
                        puntos_intermedios.push(element)
                    }
                }
            }

            var j = 0;
           if(servicioConfirmado.servicio.hasOwnProperty('precioCombinaciones'))
           {
               for (const keyC in servicioConfirmado.servicio.precioCombinaciones[servicioConfirmado.combinacion].combinacion) {
                   for(var i = 0; i< servicioConfirmado.servicio.precioCombinaciones[servicioConfirmado.combinacion].combinacion[keyC];i++)
                   {
                       j++;
                       series.push(j);
                   }
                   if(servicioConfirmado.servicio.precioCombinaciones[servicioConfirmado.combinacion].combinacion[keyC]>0)
                   {
                    const keyCSplited = keyC.split(" - ");
                    tipoUnidades+= keyCSplited[0]+",";
                   }
                  
               }
                if(tipoUnidades.length>0)
                {
                    tipoUnidades = tipoUnidades.substring(0,tipoUnidades.length-1);
                    //info_adicional.unidadesSolicitadas = tipoUnidades;
                }
           }
           
           if(servicioConfirmado.servicio.hasOwnProperty('combinacion'))
           {
               for (const keyC in servicioConfirmado.servicio.combinacion) {
                   for(var i = 0; i< servicioConfirmado.servicio.combinacion[keyC];i++)
                   {
                       j++;
                       series.push(j);
                   }
                   if(servicioConfirmado.servicio.combinacion[keyC]>0)
                   {
                    const keyCSplited = keyC.split(" - ");
                    tipoUnidades+= keyCSplited[0]+",";
                   }
                  
               }
               if(tipoUnidades.length>0)
                {
                    tipoUnidades = tipoUnidades.substring(0,tipoUnidades.length-1);
                    //info_adicional.unidadesSolicitadas = tipoUnidades;
                }
           }

            horaInicio  = servicioConfirmado.servicio.itinerario.inicioDeServicio;
            horaFin  = servicioConfirmado.servicio.itinerario.finDeServicio;

            origen.alias = servicioConfirmado.servicio.origen.alias
            destino.alias = servicioConfirmado.servicio.destino.alias

            origen.direccion = servicioConfirmado.servicio.origen.direccion
            destino.direccion = servicioConfirmado.servicio.destino.direccion

            origen.lat = servicioConfirmado.servicio.origen.coordenadas.lat
            origen.lng = servicioConfirmado.servicio.origen.coordenadas.lng

            destino.lat = servicioConfirmado.servicio.destino.coordenadas.lat
            destino.lng = servicioConfirmado.servicio.destino.coordenadas.lng

           origen.referencias = servicioConfirmado.servicio.origen.referencias
           destino.referencias = servicioConfirmado.servicio.destino.referencias
        });

        for (const key in series) {
            series[key] = series[key]+ "/" + series.length;
        }

        var horasCotizadas = cotizacion.horasCotizadas ? cotizacion.horasCotizadas : 0;
        var horasRegresoCotizadas = cotizacion.horasRegresoCotizadas ? cotizacion.horasRegresoCotizadas : 0;
        var porcentajeAplicado = cotizacion.porcentajeAplicado ? cotizacion.porcentajeAplicado : 0;
        const puedeUsarOperadorExternoValue = puedeUsarOperadorExterno ? 'Si' : 'No';

        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'origen=' + JSON.stringify(origen) +
                        '&destino='+JSON.stringify(destino)+
                        '&tipoDeViaje='+tipoDeViaje+
                        '&series='+JSON.stringify(series)+
                        '&pasajeros=[]'+
                        '&puntos_intermedios='+JSON.stringify(puntos_intermedios)+
                        '&info_adicional='+JSON.stringify(info_adicional)+
                        '&cliente='+cotizacion.cliente+
                        '&horaInicio='+horaInicio+
                        '&horaFin='+horaFin+
                        '&id_confirmacion='+id_confirmacion+
                        '&idTrosten='+idTrosten+
                        '&idNegocioHubSpot='+idHubSpot+
                        '&horasCotizadas='+horasCotizadas+
                        '&horasRegresoCotizadas='+horasRegresoCotizadas+
                        '&porcentajeAplicado='+porcentajeAplicado+
                        '&tipoUnidades='+tipoUnidades+
                        '&parejas='+JSON.stringify(parejas)+
                        '&zona='+cotizacion.zona+
                        '&asignacionEspecial='+asignacionEspecial+
                        '&puedeUsarOperadorExterno='+puedeUsarOperadorExternoValue;
        const body_scaped = body// body.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\x20-\x7E]/gmi, "")


        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/agregarRutaTuristica.php', body_scaped,{headers});

        //return this.http.post('', body,{headers});
    }
    public actualizarSolicitudesDeDisponibilidad(key_cotizacion,info_confirmacion)
    {
      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'key_cotizacion='+key_cotizacion+
            '&info_confirmacion='+JSON.stringify(info_confirmacion);

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/actualizarConfirmacionEnSolicitudPorKeyCotizacion.php', body,{headers});
    }
    public crearRutaTurismoCorpSchoolDetalleConfirmacion(cotizacion,serviciosConfirmados,id_confirmacion,idTrosten,cliente){

        var info_adicional = {
            conceptosAdicionales:"",
            notas:"",
            indicacionesEspeciales:"",
            notasOperaciones:"",
        }
        var origen = {
            alias:"",
            lat:"",
            lng:"",
            direccion:"",
            referencias:""
        }
        var destino = {
            alias:"",
            lat:"",
            lng:"",
            direccion:"",
            referencias:""
        }

        var puntos_intermedios = []

        var horaInicio = 0;
        var horaFin = 0;

        var series = [];

        var tipoDeViaje= ""

        serviciosConfirmados.forEach(servicioConfirmado => {
            if(servicioConfirmado.servicio.hasOwnProperty('tipoDeViaje'))
                tipoDeViaje = servicioConfirmado.servicio.tipoDeViaje;

            if(servicioConfirmado.servicio.hasOwnProperty('conceptosAdicionales'))
                info_adicional.conceptosAdicionales = servicioConfirmado.servicio.conceptosAdicionales;
            if(servicioConfirmado.servicio.hasOwnProperty('notas'))
                info_adicional.notas = servicioConfirmado.servicio.notas;
            if(servicioConfirmado.servicio.hasOwnProperty('indicacionesEspeciales'))
                info_adicional.indicacionesEspeciales = servicioConfirmado.servicio.indicacionesEspeciales;
            if(servicioConfirmado.servicio.hasOwnProperty('notasOperaciones'))
                info_adicional.notasOperaciones = servicioConfirmado.servicio.notasOperaciones;
            if(servicioConfirmado.servicio.hasOwnProperty('puntosIntermedios'))
            {
                for (const key in servicioConfirmado.servicio.puntosIntermedios) {
                    if (servicioConfirmado.servicio.puntosIntermedios.hasOwnProperty(key)) {
                        const element = servicioConfirmado.servicio.puntosIntermedios[key];
                        element.id=key;
                        puntos_intermedios.push(element)
                    }
                }
            }

            var j = 0;
            if(servicioConfirmado.servicio.hasOwnProperty('unidadesSolicitadas'))
            {
                for (const keyU in servicioConfirmado.servicio.unidadesSolicitadas) {
                    for(var i = 0; i< servicioConfirmado.servicio.unidadesSolicitadas[keyU];i++)
                    {
                        j++;
                        series.push(j);
                    }
                }
            }

            horaInicio  = servicioConfirmado.servicio.itinerario? servicioConfirmado.servicio.itinerario.inicioDeServicio : servicioConfirmado.servicio.inicioDeServicio;
            horaFin  = servicioConfirmado.servicio.itinerario? servicioConfirmado.servicio.itinerario.finDeServicio : servicioConfirmado.servicio.finDeServicio;

            origen.alias = servicioConfirmado.servicio.origen.alias
            destino.alias = servicioConfirmado.servicio.destino.alias

            origen.direccion = servicioConfirmado.servicio.origen.direccion
            destino.direccion = servicioConfirmado.servicio.destino.direccion

            origen.lat = servicioConfirmado.servicio.origen.coordenadas.lat
            origen.lng = servicioConfirmado.servicio.origen.coordenadas.lng

            destino.lat = servicioConfirmado.servicio.destino.coordenadas.lat
            destino.lng = servicioConfirmado.servicio.destino.coordenadas.lng

            origen.referencias = servicioConfirmado.servicio.origen.referencias
            destino.referencias = servicioConfirmado.servicio.destino.referencias
        });

        for (const key in series) {
            series[key] = series[key]+ "/" + series.length;
        }

        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        //const body = 'json=' + JSON.stringify(json);
        //console.log("json",json)

        var horasCotizadas = cotizacion.horasCotizadas ? cotizacion.horasCotizadas : 0;
        var horasRegresoCotizadas = cotizacion.horasRegresoCotizadas ? cotizacion.horasRegresoCotizadas : 0;
        var porcentajeAplicado = cotizacion.porcentajeAplicado ? cotizacion.porcentajeAplicado : 0;

        const body = 'origen=' + JSON.stringify(origen) +
            '&destino='+JSON.stringify(destino)+
            '&tipoDeViaje='+tipoDeViaje+
            '&series='+JSON.stringify(series)+
            '&pasajeros=[]'+
            '&puntos_intermedios='+JSON.stringify(puntos_intermedios)+
            '&info_adicional='+JSON.stringify(info_adicional)+
            '&cliente='+cliente+
            '&horaInicio='+horaInicio+
            '&horaFin='+horaFin+
            '&id_confirmacion='+id_confirmacion+
            '&idTrosten='+idTrosten+
            '&horasCotizadas='+horasCotizadas+
            '&horasRegresoCotizadas='+horasRegresoCotizadas+
            '&porcentajeAplicado='+porcentajeAplicado;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/agregarRutaTuristica.php', body,{headers});

        //return this.http.post('', body,{headers});
    }


    public editarRutaTurismoCorpSchool(idConfirmacion,col,data,what){

        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'columna='+col+
            '&what='+what+
            '&idConfirmacion='+idConfirmacion+
            '&data='+data;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/editarRutaTuristica.php', body,{headers});

    }

    public actualizarRutaTurismoCorpSchool(idConfirmacion,objServicio){

      var info_adicional = {
        conceptosAdicionales:objServicio.conceptosAdicionales,
        notas:objServicio.notas,
        indicacionesEspeciales:objServicio.indicacionesEspeciales,
        notasOperaciones:objServicio.notasOperaciones,
    }
    var origen = {
        alias:objServicio.origen.alias,
        lat:  objServicio.origen.coordenadas.lat,
        lng:  objServicio.origen.coordenadas.lng,
        direccion:objServicio.origen.direccion,
        referencias:objServicio.origen.referencias
    }
    var destino = {
        alias:objServicio.destino.alias,
        lat:  objServicio.destino.coordenadas.lat,
        lng:  objServicio.destino.coordenadas.lng,
        direccion:objServicio.destino.direccion,
        referencias:objServicio.destino.referencias
    }

    var tipoDeViaje= objServicio.tipoDeViaje

    var puntos_intermedios = JSON.stringify(objServicio.puntosIntermedios)

       var horaInicio = objServicio.inicioDeServicio;
       var horaFin = objServicio.finDeServicio;

      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

      const body = 
          'idConfirmacion='+idConfirmacion+
          '&origen='+JSON.stringify(origen)+
          '&destino='+JSON.stringify(destino)+
          '&tipoDeViaje='+tipoDeViaje+
          '&puntos_intermedios='+puntos_intermedios+
          '&info_adicional='+JSON.stringify(info_adicional)+
          '&horaInicio='+horaInicio+
          '&horaFin='+horaFin+
          '&porcentajeAplicado='+objServicio.porcentajeAplicado;

          console.log("body",body)
      return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/actualizarRutaTuristica.php', body,{headers});

    }
    public editarSeriesRutaTurismo(idConfirmacion,numeroUnidades){

        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'numeroUnidades='+numeroUnidades+
            '&idConfirmacion='+idConfirmacion;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/editarSeriesRutaTurismo.php', body,{headers});

    }

    public insertarConfirmacionNuevaTabla(key_confirmacion,data_confirmacion,tabla) {
        let batch = this.afs.firestore.batch();
        batch.set(this.afs.firestore.collection('confirmaciones'+tabla).doc(key_confirmacion),data_confirmacion);

        let promiseRealtimeDB = batch.commit();
        return Promise.all([promiseRealtimeDB,{$key: key_confirmacion,idTrosten:data_confirmacion.idTrosten}]);
    }

    public aplicarDescuentosEnConfirmacion(keyConfirmacion,objConfirmacion)
    {
      return this.afs.collection('confirmaciones').doc(keyConfirmacion).update({
        subtotal : objConfirmacion.subtotal,
        iva : objConfirmacion.iva,
        total : objConfirmacion.total,
        descuentoMarketing : objConfirmacion.descuentoMarketing,
        descuentoAdmin : objConfirmacion.descuentoAdmin,
        descuentoAdicional : objConfirmacion.descuentoAdicional,
      });
    }

    public eliminarDescuentoEnConfirmacion(keyConfirmacion,values)
    {
      return this.afs.collection('confirmaciones').doc(keyConfirmacion).update({
        subtotal : values.subtotal,
        iva : values.iva,
        total : values.total,
        descuentoMarketing : values.descuentoMarketing,
        descuentoAdmin : values.descuentoAdmin,
        descuentoAdicional : values.descuentoAdicional,
      });
    }

  // Crea una confirmación
    public crearConfirmacion(cotizacion, serviciosConfirmados, usuario, vendedor, numeroDeConfirmacion, cuenta:any, descuentoAdicional, descuentoMarketing, descuentoAdmin, subtotalSinDescuento, totalSinDescuento){
    // Crea un Firebase ID para que sea el nuevo ID de la confirmación
    const firebaseIdConfirmacion = this.afs.createId();

    // Fecha del momento
    let fecha = new Date(Date.now());

    /*
      Se crea el nuevo ID Trosten para la confirmación
      El ID Trosten se genera de:
      - V
      - Iniciales de vendedor
      - Guión
      - Año en curso (últimos dos dígitos)
      - Contador de confirmaciones
    */
      let nomenclatura = cotizacion.tipoDeVenta === "Activaciones" ? "M" : cotizacion.tipoDeVenta.charAt(0)

    let idTrosten:string = 'V'+nomenclatura + vendedor.nombre.charAt(0) + vendedor.apellidoPaterno.charAt(0) + vendedor.apellidoMaterno.charAt(0) + '-' + fecha.getFullYear().toString().substring(2,4) + numeroDeConfirmacion;
    idTrosten = idTrosten.toUpperCase();

    var idNegocioHubSpot_aux = {}
    if(cotizacion.idNegocioHubSpot)
    {
        idNegocioHubSpot_aux = {
            idNegocioHubSpot:cotizacion.idNegocioHubSpot,
        }
    }

    const puedeUsarOperadorExternoValue = cotizacion.puedeUsarOperadorExterno ? 'Si' : 'No';

    // Inicialización de objeto de confirmación
        let objConfirmacion:any = {
          conceptosAdicionales: cotizacion.conceptosAdicionales,
            horasCotizadas : cotizacion.horasCotizadas,
            horasRegresoCotizadas : cotizacion.horasRegresoCotizadas,
            porcentajeAplicado : cotizacion.porcentajeAplicado,
            subtotalSinDescuento: subtotalSinDescuento,
            totalSinDescuento: totalSinDescuento,
            descuentoAdmin: descuentoAdmin,
            descuentoMarketing: descuentoMarketing,
            descuentoAdicional: descuentoAdicional,
            aliasOrigen: cotizacion.aliasOrigen,
            aliasDestino: cotizacion.aliasDestino,
            cliente: cotizacion.cliente,
            cotizacion: cotizacion.$key,
            fechaDeConfirmacion: fecha.valueOf(),
            tipoDeVenta: cotizacion.tipoDeVenta,
            usuarioQueConfirmo: usuario,
            fueEnviada: false,
            fueLeida: false,
            zona: cotizacion.zona,
            disponibilidadAlConfirmar: {
                color: cotizacion.colorDisponibilidadAlConfirmar || null,
                razonColor: cotizacion.razonBajaDisponibilidad || null
            },
            estatus: 'Confirmada',
            idTrosten: idTrosten,
            ...idNegocioHubSpot_aux,
            idCotizacionTrosten: cotizacion.idTrosten,
            contactos: {
                contratante: cotizacion.contratante,
                coordinador: cotizacion.coordinador,
                usuario: cotizacion.usuario
            },
            liquidada: false,
            montoPagado: 0,
            total: cuenta.total, //  El usuario calcula estos montos en la pantalla de creación de confirmación
            subtotal: cuenta.subtotal,
            iva: cuenta.iva,
            requiereFactura: cuenta.requiereFactura,
            puedeUsarOperadorExterno: puedeUsarOperadorExternoValue ? 'Si' : 'No',
            servicios: {} // Esto simbolizan la "plantilla de los servicios que se van a crear"
        }

    // Checa el tipo de venta de la cotización y si es de tipo corporativo o escolar.
    // agrega una bandera para después usarla en planeación
    if(objConfirmacion.tipoDeVenta == 'Corporativo' || objConfirmacion.tipoDeVenta == 'Escolar')
      objConfirmacion['asignacionMasivaDeViajes'] = false;

    // Checa si la cotización tiene referencia de empleado
    if(cotizacion.hasOwnProperty('referenciaDeEmpleado'))
      objConfirmacion['referenciaDeEmpleado'] = cotizacion.referenciaDeEmpleado;

    // Almacena los itinerarios de la primer repetición de cada servicio
    let itinerarios:any = {};
    // Almacena las repeticiones de cada servicio
    let repeticiones:any = {};

    // Realiza un barrido por los servicios seleccionados para
    // Configurar el total a a pagar y los servicios seleccionados
    serviciosConfirmados.forEach(servicioConfirmado => {
      // Genera el objeto itinerario para cada una de las repeticiones
      itinerarios[servicioConfirmado.idServicio] = this.generarObjetoItinerario(servicioConfirmado.servicio.itinerario);

      // Agrega las repeticiones del servicio confirmado a al objeto de repeticiones
      //repeticiones[servicioConfirmado.idServicio] = servicioConfirmado.repeticiones;

      // Generar el nuevo nodo de servicios seleccionados para guardar en la confirmación

        var precio;
        var unidades;
        if(servicioConfirmado.servicio.punto_origen)
        {
            precio = servicioConfirmado.servicio.precioCombinaciones[servicioConfirmado.combinacion].total
            unidades = servicioConfirmado.servicio.precioCombinaciones[servicioConfirmado.combinacion].combinacion
        }
        else {
            precio = servicioConfirmado.servicio.precioCombinaciones[servicioConfirmado.combinacion]
            unidades = servicioConfirmado.servicio.costoCombinaciones[servicioConfirmado.combinacion]
        }

        let objServicio = {
            origen : servicioConfirmado.servicio.origen,
            destino : servicioConfirmado.servicio.destino,
            oficinaDeOrigen : servicioConfirmado.servicio.oficinaDeOrigen,
            tipoDeViaje : servicioConfirmado.servicio.tipoDeViaje,
            parametros : servicioConfirmado.servicio.parametros,
            combinacion : {
                precio : precio,
                unidades : unidades
            },
            disponibilidadFlexible:servicioConfirmado.disponibilidadFlexible,
            itinerario:servicioConfirmado.servicio.itinerario,
        };

        if(servicioConfirmado.servicio.kilometros_a_cotizar)
        {
            objServicio['kilometros_a_cotizar'] = servicioConfirmado.servicio.kilometros_a_cotizar;
            objConfirmacion.kilometros_a_cotizar = servicioConfirmado.servicio.kilometros_a_cotizar
        }


      // Checar para agregar conceptos adicionales, notas, indicaciones especiales, puntos intermedios
      if(objConfirmacion.tipoDeVenta == 'Corporativo' && servicioConfirmado.servicio.hasOwnProperty('rutaCorporativa'))
        objServicio['rutaCorporativa'] = servicioConfirmado.servicio.rutaCorporativa;
      if(servicioConfirmado.servicio.hasOwnProperty('conceptosAdicionales'))
        objServicio['conceptosAdicionales'] = servicioConfirmado.servicio.conceptosAdicionales;
      if(servicioConfirmado.servicio.hasOwnProperty('notas'))
        objServicio['notas'] = servicioConfirmado.servicio.notas;
      if(servicioConfirmado.servicio.hasOwnProperty('indicacionesEspeciales'))
        objServicio['indicacionesEspeciales'] = servicioConfirmado.servicio.indicacionesEspeciales;
      if(servicioConfirmado.servicio.hasOwnProperty('notasOperaciones'))
        objServicio['notasOperaciones'] = servicioConfirmado.servicio.notasOperaciones;
      if(servicioConfirmado.servicio.hasOwnProperty('puntosIntermedios'))
        objServicio['puntosIntermedios'] = servicioConfirmado.servicio.puntosIntermedios;

      // Agregar con el mismo id de firebase del servicio a este nuevo
      objConfirmacion.servicios[servicioConfirmado.idServicio] = objServicio;
    });

    // Genera todos los servicios que se contrataron en la confirmación
    let servicios = this.generarServiciosDeConfirmacion(objConfirmacion, itinerarios, repeticiones, firebaseIdConfirmacion);

    // Realiza la operación atómica en angular firestore
    let batch = this.afs.firestore.batch();
    batch.set(this.afs.firestore.collection('confirmaciones').doc(firebaseIdConfirmacion),objConfirmacion);

    let multipath = {};
    // Agrega a la BD la confirmación
    // Cambia de estatus la cotización a "Confirmada"
    multipath['cotizaciones/' + objConfirmacion.cotizacion + '/estatus/'] = 'Confirmada';
    multipath['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + objConfirmacion.cotizacion + '/estatus/'] = 'Confirmada';
    // Agrega el id de confirmación a la cotización para poder referenciarla desde ahí
    multipath['cotizaciones/' + objConfirmacion.cotizacion + '/confirmacion/'] = firebaseIdConfirmacion;
    multipath['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + objConfirmacion.cotizacion + '/confirmacion/'] = firebaseIdConfirmacion;
    // Aumenta el número de confirmaciones creadas
    multipath['contadores/numeroConfirmaciones/'] = numeroDeConfirmacion + 1;
    multipath['clientes/' + cotizacion.cliente + '/estatus/'] = 'Cliente';

    // Elimina los servicios que se habían creado cuando se realizó el cambio a posible si es que la cotización tiene un estatus posible
    if(cotizacion.hasOwnProperty('serviciosPosibles')){
      multipath['cotizaciones/' + cotizacion.$key + '/serviciosPosibles/'] = null;
      multipath['cotizacionesPorusuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/serviciosPosibles/'] = null;
      for(let idServicioPosible in cotizacion.serviciosPosibles){
        batch.delete(this.afs.firestore.collection('servicios').doc(idServicioPosible));
      }
    }

    // Agrega todos los servicios que se van a realizar
    for(let idServicio in servicios){
      batch.set(this.afs.firestore.collection('servicios').doc(idServicio),servicios[idServicio]);
    }

    batch.update(this.afs.firestore.collection('cotizaciones').doc(cotizacion.$key),{estatus:'Confirmada'})
    batch.update(this.afs.firestore.collection('cotizaciones').doc(cotizacion.$key),{confirmacion:firebaseIdConfirmacion})
    batch.update(this.afs.firestore.collection('cotizaciones').doc(cotizacion.$key),{serviciosPosibles:null})

    let promiseFirestore = this.afDB.object('/').update(multipath);
    let promiseRealtimeDB = batch.commit();

    if (cotizacion.colorDisponibilidadAlConfirmar === 'red' && cotizacion.razonBajaDisponibilidad) {
      this.enviarCorreoService.notificarConfirmacionEnRojo(idTrosten, cotizacion.idTrosten, cotizacion.razonBajaDisponibilidad);
    }

    return Promise.all([promiseFirestore, promiseRealtimeDB,{$key: firebaseIdConfirmacion,idTrosten:idTrosten}]);
  }

  /**
   * Calcula el monto total a pagar con el cliente hablando de SUBTOTAL
   * @param serviciosConfirmados
   */
  public calcularMontoSubtotal(serviciosConfirmados:Array<any>){
    // Almacena el monto total de la confirmación
    let totalConfirmacion:number = 0;
    // Hace un loop por todos los servicios confirmados
    serviciosConfirmados.forEach(servicioConfirmado => {
      // Almacena el total del servicio
      let totalServicio = 0;
      // Agrega al precio total del servicio el precio de la combinación completa
        //console.log("servicioConfirmado",servicioConfirmado)
        if(servicioConfirmado.servicio.punto_origen)
        {
            totalServicio += servicioConfirmado.servicio.precioCombinaciones[servicioConfirmado.combinacion].total;
        }
        else {
            totalServicio += servicioConfirmado.servicio.precioCombinaciones[servicioConfirmado.combinacion];
            //totalServicio *= servicioConfirmado.repeticiones.length;
        }
      // Multiplica por la cantidad de repeticiones
      //totalServicio *= servicioConfirmado.repeticiones.length;
      // Aumenta el precio total del servicio al precio completo de la confirmación
      totalConfirmacion += totalServicio;
    });
    return totalConfirmacion;
  }

  // Genera el objeto de itinerario para poder manipularlo después por cada repetición
  private generarObjetoItinerario(itinerario):any{
    let objItinerario = {
      duracionDeServicio : itinerario.finDeServicio - itinerario.inicioDeServicio // Diferencia que hay entre el inicio y el fin del servicio
    };
    if(itinerario.hasOwnProperty('llegadaADestino'))
      objItinerario['llegadaADestino'] = itinerario.llegadaADestino - itinerario.inicioDeServicio;
    if(itinerario.hasOwnProperty('regresoAOrigen'))
      objItinerario['regresoAOrigen'] = itinerario.finDeServicio - itinerario.regresoAOrigen;

    return objItinerario;
  }

  // Genera la lista de servicios
  private generarServiciosDeConfirmacion(confirmacion, itinerarios, repeticiones, idConfirmacion):any{
    // Objeto para almacenar todos los servicios de la cotización
    let servicios = {};
    // Inicializa el número de control del servicio
    let numeroDeServicio = 1;
    // Hace un loop por los servicios
    for(let idServicio in confirmacion.servicios){
      // Variale para acceder al servicio
      let servicio = confirmacion.servicios[idServicio];
      console.log("servicio",servicio)

      // Realiza un loop por cada una de las repeticiones del servicio
      for(let i = 0;i < servicio.parametros.repeticionesDelServicio; i++){
        // Crea un nuevo id de firebase para cada servicio
        let firebaseIdServicio = this.afs.createId();

        // Configuración de cad objeto servicio
        let objServicio = {
          aliasOrigen : confirmacion.aliasOrigen,
          aliasDestino : confirmacion.aliasDestino,
          cliente : confirmacion.cliente,
          estatus : 'No Asignado',
          servicio : idServicio,
          numeroDeServicio : numeroDeServicio,
          confirmacion : idConfirmacion,
          idConfirmacion : confirmacion.idTrosten,
          tipoDeVenta : confirmacion.tipoDeVenta,
          tipoDeViaje : servicio.tipoDeViaje,
          oficinaDeOrigen : servicio.oficinaDeOrigen,
          contactos : confirmacion.contactos,
          origen : servicio.origen,
          destino : servicio.destino,
          cantidadDeOperadores : servicio.parametros.cantidadDeOperadores,
          cantidadDePasajeros : servicio.parametros.cantidadDePasajeros,
          nochesDeHospedaje : servicio.parametros.nochesDeHospedaje,
          kilometrosDeEstadia : servicio.parametros.kilometrosDeEstadia,
          kilometrosDeDistancia : servicio.parametros.kilometrosDeDistancia,
          usuarioQueConfirmo : confirmacion.usuarioQueConfirmo,
          notas:servicio.notas,
          indicacionesEspeciales:servicio.indicacionesEspeciales,
          notasOperaciones:servicio.notasOperaciones || '',
          inicioDeServicio : servicio.itinerario.inicioDeServicio,//repeticiones[idServicio][i],
          finDeServicio : servicio.itinerario.finDeServicio, //repeticiones[idServicio][i] + itinerarios[idServicio].duracionDeServicio,
          disponibilidadFlexible:servicio.disponibilidadFlexible,
          puedeUsarOperadorExterno: confirmacion.puedeUsarOperadorExterno,
          unidadesSolicitadas : {} // Se configuran más abajo
        };

        // Incrementa el numero de control de los servicios
        numeroDeServicio++;

        // Agregar al servicio si tiene notas
        if(servicio.hasOwnProperty('notas'))
          objServicio['notas'] = servicio.notas;
        // Agregar si tiene puntos intermedios
        if(servicio.hasOwnProperty('puntosIntermedios'))
          objServicio['puntosIntermedios'] = servicio.puntosIntermedios;
        // Agregar si partes del itinerario faltantes en su caso
        if(itinerarios[idServicio].hasOwnProperty('llegadaADestino'))
          objServicio['llegadaADestino'] = servicio.itinerario.llegadaADestino//servicio.itinerario.[idServicio][i] + itinerarios[idServicio].llegadaADestino;
        if(itinerarios[idServicio].hasOwnProperty('regresoAOrigen'))
          objServicio['regresoAOrigen'] = servicio.itinerario.regresoAOrigen//objServicio.finDeServicio - itinerarios[idServicio].regresoAOrigen;

        // Configurar las unidades del servicio
        for(let idUnidad in servicio.combinacion.unidades){
            if(!isNaN(servicio.oficinaDeOrigen))
            {
                objServicio.unidadesSolicitadas[idUnidad] = servicio.combinacion.unidades[idUnidad];
            }
            else {
                objServicio.unidadesSolicitadas[idUnidad] = servicio.combinacion.unidades[idUnidad].numeroDeUnidades;
            }
        }

        // Configurar los conceptos adicionales
        if(servicio.hasOwnProperty('conceptosAdicionales')){
          let conceptosAdicionales = {};
          for(let conceptoId in servicio.conceptosAdicionales){
            conceptosAdicionales[conceptoId] = servicio.conceptosAdicionales[conceptoId]//servicio.conceptosAdicionales[conceptoId].descripcion;
          }
          objServicio['conceptosAdicionales'] = conceptosAdicionales;
        }

        // Añade el objeto servicio al arreglo de servicios que se van a crear
        servicios[firebaseIdServicio] = objServicio;
      }
    }
    return servicios;
  }

  /**
   * Obtiene las confirmaciones del usuario que no estén pagadas al 100% que correspondan a un usuario en especifico
   * @param uid Id del usuario del cual se quieren las confirmaciones
   */
  public obtenerConfirmacionesNoLiquidadasPorusuario(uid:string){
    return this.afs.collection('confirmaciones', ref => ref.where('usuarioQueConfirmo','==',uid).where('liquidada', '==', false).where('estatus','==','Confirmada'));
  }

  public obtenerConfirmacionesNoLiquidadasPorusuarioPage(
    uid: string,
    pageSize: number,
    startAfterDoc?: any // DocumentSnapshot
  ): Observable<{ items: any[]; firstDoc: any; lastDoc: any; hasNext: boolean }> {
    return this.afs
      .collection('confirmaciones', ref => {
        let q = ref
          .where('usuarioQueConfirmo', '==', uid)
          .where('liquidada', '==', false)
          .where('estatus', '==', 'Confirmada')
          .orderBy('fechaDeConfirmacion', 'desc')
          .limit(pageSize + 1); // sentinel
        if (startAfterDoc) q = q.startAfter(startAfterDoc);
        return q;
      })
      .snapshotChanges()
      .map(snaps => {
        const docs = snaps.map(s => s.payload.doc);
        let items = docs.map(d => ({ $key: d.id, ...d.data() })).filter(d=> d["montoPagado"] !== d["total"]);
        

        const hasNext = items.length > pageSize;
        if (hasNext) items = items.slice(0, pageSize);

        const firstDoc = docs.length ? docs[0] : null;
        const lastDoc  = docs.length ? docs[Math.min(docs.length, pageSize) - 1] : null;

        return { items, firstDoc, lastDoc, hasNext };
      })
      .catch((err: any) => {
        console.error('[Firestore] obtenerConfirmacionesNoLiquidadasPorusuarioPage error:', err);
        return Observable.of({ items: [], firstDoc: null, lastDoc: null, hasNext: false });
      });
  }

  /**
   * Obtiene todas las confirmaciones que no se han terminado de pagar al 100%
   */
  public obtenerConfirmacionesNoLiquidadas(){
      return this.afs.collection('confirmaciones', ref => ref.where('liquidada','==',false));
  }
  public obtenerConfirmacionesNoLiquidadasEntreFechas(fehcaInicio,fechaFin){
    return this.afs.collection('confirmaciones', ref => ref.orderBy('fechaDeConfirmacion','asc').startAt(fehcaInicio).endAt(fechaFin).where('liquidada','==',false));
}

  /**
   * Marca una confirmación como enviada y leida por el cliente
   * @param idConfirmacion
   * @param usuarioQueConfirmo
   */
  public marcarComoLeida(idConfirmacion:string){
    return this.afs.collection('confirmaciones').doc(idConfirmacion).update({
      fueEnviada : true,
      fueLeida : true
    });
  }

  public actualizarIva (objConfirmacion,idConfirmacion)
  {
      return this.afs.collection('confirmaciones').doc(idConfirmacion).update({
          subtotal : objConfirmacion.subtotal,
          iva : objConfirmacion.iva,
          total : objConfirmacion.total,
          requiereFactura : objConfirmacion.requiereFactura,
      });
  }

    public actualizarIdTrosten (nuevoIdTrosten,idConfirmacion)
    {
        return this.afs.collection('confirmaciones').doc(idConfirmacion).update({
            idTrosten : nuevoIdTrosten
        });
    }


  public actualizarEventoIdConfirmacion(idConfirmacion:string, eventoId:string){
      console.log('[ConfirmacionesService] actualizarEventoIdConfirmacion', { idConfirmacion, eventoId });
      return this.afs.collection('confirmaciones').doc(idConfirmacion).update({
          eventoId : eventoId
      });
  }

  public limpiarEventoIdConfirmacion(idConfirmacion:string){
      console.log('[ConfirmacionesService] limpiarEventoIdConfirmacion', { idConfirmacion });
      return this.afs.collection('confirmaciones').doc(idConfirmacion).update({
          eventoId : null
      });
  }

    public aumentarContadorConfirmaciones (numeroConfirmaciones)
    {
        let multipath = {};
        multipath['contadores/numeroConfirmaciones/'] = numeroConfirmaciones + 1;
        return this.afDB.object('/').update(multipath);
    }

    public actualizarKilometrosDeDistancia (objConfirmacion,idConfirmacion)
    {
        return this.afs.collection('confirmaciones').doc(idConfirmacion).update({
            servicios :objConfirmacion.servicios
        });
    }

    public actualizarKilometrosCotizados (objConfirmacion,idConfirmacion)
    {
        return this.afs.collection('confirmaciones').doc(idConfirmacion).update({
            servicios :objConfirmacion.servicios,
            kilometros_a_cotizar: objConfirmacion.kilometros_a_cotizar
        });
    }


  /**
   * Envía la liga de la confirmación al cliente
   * @param idConfirmacion
   * @param confirmacion
   * @param cliente
   */

  public enviarConfirmacionWhatsappCliente(idConfirmacion:string, contacto:any, confirmacion:any){
    const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

    const url = "https://operacion.trosten.com/#/confirmacion/"+idConfirmacion;
    const confirmacionMessage = `Origen: ${confirmacion.aliasOrigen} - Destino: ${confirmacion.aliasDestino} - Más información en: ${url}`;	
      let mensaje = "Hola "+contacto.nombre+", aquí tienes la confirmación de tu viaje:"+confirmacionMessage;
      let dataToSend = {
        contacto_tel: "+521"+contacto.telefono,
        message: mensaje
      }
    function serialize (obj) {
      const str = []
      for (const p in obj) {
        if (obj.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
        }
      }
      return str.join('&')
    }

    const dataUrlEncoded = serialize(dataToSend)

    console.log('dataToSend',dataUrlEncoded)
    const body = 'contacto_tel=' +dataUrlEncoded;
  
    return this.http.post('https://operacion.trosten.com/send-whatsapp/sendSimpleWhatsapp.php', body,{headers});
  }
  public enviarConfirmacionCliente(idConfirmacion:string, contacto:any, confirmacion:any){
    /*let body = {
        aliasOrigen:confirmacion.aliasOrigen,
        aliasDestino:confirmacion.aliasDestino,
        email : contacto.email,
        origen : 'confirmacion',
        id : idConfirmacion,
        host : environment.host,
        idContacto:contacto.$key,
        mensaje: contacto.mensaje,
    };
    return this.http.post('https://us-central1-trosten-efcb3.cloudfunctions.net/app/enviar-email-cliente', body);*/

      let url = "https://operacion.trosten.com/#/confirmacion/"+idConfirmacion;

      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

      const body = 'idTrosten=' + confirmacion.idTrosten +'&emailReceptor='+contacto.email+'&nombreReceptor='+contacto.nombre+'&tipoViaje='+confirmacion.tipoDeVenta+'&linkPdf='+url;

      //return this.http.post('https://us-central1-trosten-efcb3.cloudfunctions.net/app/enviar-email-cliente', body);
      return this.http.post('https://operacion.trosten.com/pdf-service/email_cotizacion/sendEmailPDF-confirmacion.php', body,{headers});
  }

  /**
   * Marca la confirmación como enviada para el cliente
   * @param confirmacion
   */
  public marcarConfirmacionComoEnviada(idConfirmacion:string){
    // Actualiza el estatus de "Enviado al cliente"
    return this.afs.collection('confirmaciones').doc(idConfirmacion).update({ fueEnviada : true });
  }

    /**
     * Cancela una confirmacion
     */
    public cancelarConfirmacion(devolucion:DevolucionDeDinero,currentSaldo:number):Promise<any>{
		// Objeto para realizar la operación atómica en angular firestore
      let batch = this.afs.firestore.batch();
       let multipathUpdateCotizacionPosible = {};
       if(currentSaldo==undefined){
           currentSaldo=0;
       }
        devolucion.saldoAFavor = currentSaldo + devolucion.saldoAFavor;
        multipathUpdateCotizacionPosible['clientes/' + devolucion.cliente + '/saldoAFavor/'] = devolucion.saldoAFavor;
        
        let promiseRealtimeDB = this.afDB.object('/').update(multipathUpdateCotizacionPosible);

      // Cambia el estatus de la confirmacion
      batch.update(this.afs.firestore.collection('confirmaciones').doc(devolucion.confirmacion), { estatus : 'Cancelada', fechaCancelacion: Date.now() });
      // Crea un nuevo objeto de confirmacion y lo manda a la base de datos
      const firebaseIdDevolucion = this.afs.createId();
      devolucion.fecha = Date.now();
      batch.set(this.afs.firestore.collection('devolucionesDeDinero').doc(firebaseIdDevolucion), { ...devolucion });
      let promiseFirestore = batch.commit();
      return Promise.all([promiseRealtimeDB, promiseFirestore]);
    }

    public cancelarCotizacion(id, usuario){
        let multipath = {};
        // Actualiza a la BD la contizacion
        // Cambia de estatus la cotización a "Cancelada"
        multipath['cotizaciones/' + id + '/estatus/'] = 'Cancelada';
        multipath['cotizacionesPorUsuario/' + usuario + '/' + id + '/estatus/'] = 'Cancelada';
        return this.afDB.object('/').update(multipath);
    }

    public cancelarServicio(id){
        let batch = this.afs.firestore.batch();
        // Cambia el estatus de la confirmacion
        batch.update(this.afs.firestore.collection('servicios').doc(id), { estatus : 'Cancelada' });

        return batch.commit();
    }

    /**
     * Obtiene las devoluciones de dinero por confirmación
     * @param idConfirmacion
     */
    public obtenerDevolucionesPorConfirmacion(idConfirmacion:string){
        return this.afs.collection('devolucionesDeDinero', ref => ref.where('confirmacion','==',idConfirmacion));
    }

    /**
     * Obtiene las devoluciones de dinero por cliente
     * @param idCliente
     */
    public obtenerDevolucionesPorCliente(idCliente:string){
        return this.afs.collection('devolucionesDeDinero', ref => ref.where('cliente','==',idCliente));
    }

    public actualizarCosto(id, costo){
        return this.afs.collection('confirmaciones').doc(id).update({total:costo})
    }

    public getInfoRutaTurismo(id_confirmacion){
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'id_confirmacion='+id_confirmacion;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/getInfoRutaTurismo.php', body,{headers});
    }
    public getInfoRutaTurismoEnPlaneacion(id_confirmacion){
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'id_confirmacion='+id_confirmacion;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/getInfoRutaTurismoEnPlaneacion.php', body,{headers});
    }

    public getInfoRutaTurismoEnPlaneacionBatch(confirmacionIds){
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'confirmacion_ids=' + JSON.stringify(confirmacionIds);

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/getInfoRutaTurismoEnPlaneacionBatch.php', body,{headers});
    }
    public getCambiosRutasTuristicas(idTrosten){
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'idTrosten='+idTrosten;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/getInfoCambioRutaTurismoPorIdTrosten.php', body,{headers});
    }

    public getInfoRutaTurismoPorIdTrosten(id_confirmacion){
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'id_confirmacion='+id_confirmacion;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/getInfoRutaTurismoPorIdTrosten.php', body,{headers});
    }

    public enviarOperadorUnidadACliente(nombre,email,ruta)
    {
        //console.log(ruta);
        var operador = JSON.parse(ruta.operador);
        var unidad = JSON.parse(ruta.unidad);

        var placas = unidad.placasFederal;

        if(placas=="")
        {
            placas = unidad.placasEstatales
        }

        var operador_txt = "Nombre: "+operador.nombre+ "Teléfono: "+operador.telefono
        var unidad_txt = "Marca: "+unidad.marca+" Placas: "+unidad.placasFederal+" Tipo: "+unidad.tipoDeUnidad+" Rótulo: "+unidad.rotulo

        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'operador=' + operador_txt +'&emailReceptor='+email+'&nombreReceptor='+nombre+'&unidad='+unidad_txt;
        return this.http.post('https://operacion.trosten.com/pdf-service/email_cotizacion/sendEmailCliente.php', body,{headers});

    }

    public traerInfoDescuentos()
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'fhrtbxdbtrbrt=autorizado';
        return this.http.post('https://operacion.trosten.com/admin-exec/php/admin/Codigos_Descuento/getCodigos.php', body,{headers});

    }

    public updateClienteNegocio(idTrosten,dealId, nombreCliente)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        var dealname = idTrosten+ " / " + nombreCliente;
        const body = 'dealId='+dealId+
            '&dealname='+dealname;

        return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/updateNegocioCliente.php', body,{headers});

    }
    public getViajesPorFechaDeInicioDeServicio(fechaInicio,fechaFin)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'time='+fechaInicio+
            '&timeF='+fechaFin;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/getRutasTuristicasPorDia.php', body,{headers});

    }
    public getSolicitudesDelUsuario(key_usuario)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'key_usuario='+key_usuario;
        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/getSolicitudesDelUsuario.php', body,{headers});
    }
    /** 🔁 PENDIENTES stream (estatus_operaciones === 'Pendiente') */
  public obtenerSolicitudesPendientesStream(uid: string, pollMs = 15000): Observable<any[]> {
    const trigger$ = merge(this.solicitudesRefresh$, interval(pollMs)).startWith(0);

    return trigger$
      .switchMap(() =>
        this.getSolicitudesDelUsuario(uid)
          .map((res: any) => {
            const arr = Array.isArray(res) ? res : [];
            return arr.filter(s => s.estatus_operaciones === 'Pendiente' && s.estatus === 'Pendiente');
          })
          .catch(_ => of([]))
      )
      // Build a fingerprint and only emit when it changes
      .map(list => ({
        list,
        fp: (list || [])
          .map(x => `${x.id_solicitud_disponibilidad || x.id || ''}|${x.estatus_operaciones || ''}|${x.fecha_creacion || ''}`)
          .join('~')
      }))
      .distinctUntilChanged((a, b) => a.fp === b.fp)
      .map(({ list }) => list)
      .shareReplay(1);
  }

  /** 🔁 ACEPTADAS stream (estatus_operaciones === 'Aceptada' && fecha_confirmacion) */
  public obtenerSolicitudesAceptadasStream(uid: string, pollMs: number = 15000): Observable<any[]> {
    const trigger$ = merge(this.solicitudesRefresh$, interval(pollMs)).startWith(0);

    return trigger$
      .switchMap(() =>
        this.getSolicitudesDelUsuario(uid)
          .map((res: any) => {
            const arr = Array.isArray(res) ? res : [];
            return arr.filter(s => s.estatus_operaciones === 'Aceptada' && s.fecha_confirmacion && s.estatus === 'Pendiente');
          })
          .catch(_ => of([]))
      )
      .map(list => ({
        list,
        fp: (list || [])
          .map(x => `${x.id_solicitud_disponibilidad || x.id || ''}|${x.estatus_operaciones || ''}|${x.fecha_confirmacion || ''}`)
          .join('~')
      }))
      .distinctUntilChanged((a, b) => a.fp === b.fp)
      .map(({ list }) => list)
      .shareReplay(1);
  }

  /** 🔔 Forzar refresh manual (afecta a ambas listas) */
  public forceSolicitudesRefresh() {
    this.solicitudesRefresh$.next(undefined);
  }

    public getSolicitudesDelUsuarioConfirmaciones(key_usuario)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'key_usuario='+key_usuario;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/DisponibilidadConfirmaciones/getSolicitudesDelUsuario.php', body,{headers});

    }
    public getSolicitudesDisponibilidad()
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = '';

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/getSolicitudesDisponibilidad.php', body,{headers});

    }

    public getSolicitudesDisponibilidadPorRangoDeFechas(fechaInicio,fechaFin,tipoDeBusqueda)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'fechaI='+fechaInicio+
            '&fechaF='+fechaFin;

        const url  = tipoDeBusqueda === "fechaCreacion" ? 'https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/getSolicitudesDisponibilidadPorRangoDeFechas.php' : 'https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/getSolicitudesDisponibilidadPorRangoDeFechasInicioDeServicio.php';

        return this.http.post(url, body,{headers});

    }

    public getSolicitudesDisponibilidadConfirmaciones()
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = '';

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/DisponibilidadConfirmaciones/getSolicitudesDisponibilidad.php', body,{headers});

    }

    public getSolicitudesDisponibilidadConfirmacionesPorIdTrosten(idTrosten)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'idTrosten='+idTrosten;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/DisponibilidadConfirmaciones/getSolicitudesPorIdTrosten.php', body,{headers});

    }

    public cambiarEstatusVentasSolicitudConfirmacion(key: string, estatus: string)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'key='+key+'&estatus='+estatus;
        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/DisponibilidadConfirmaciones/cambiarEstatusVentas.php', body,{headers});
    }

    public crearSolicitudDisponibilidadConfirmacion(key:string, objSolicitud:any,usuario:any,comentariosVentas, prioridad) {
    
      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
      const body = 'usuario_solicitante='+usuario+
          '&comentarios_ventas='+comentariosVentas+
          '&key_cotizacion='+key+
          '&prioridad='+prioridad+
          '&info_cotizacion='+JSON.stringify(objSolicitud);
          return this.http.post('https://operacion.trosten.com/corp-school/php/admin/DisponibilidadConfirmaciones/agregarSolicitudDisponibilidad.php', body,{headers});
  }


public progress$ = new Subject<{ done: number; total: number; percent: number }>();


  public updateConfirmacionHubSpotTipoClienteSiglasPuntoOrigen(objInfoUpdateHubspot)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'dealId='+objInfoUpdateHubspot.idNegocioHubSpot+
            '&tipo_cliente='+objInfoUpdateHubspot.tipo_cliente+
            '&siglas_del_agente='+objInfoUpdateHubspot.siglas_del_agente+
            '&punto_origen='+objInfoUpdateHubspot.punto_origen;

        return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/updateNegocioTipoClienteSiglasYPuntoOrigen.php', body,{headers});

    }
    public sendHubspotUpdates(items: any[]): Observable<any[]> {
          const BATCH_SIZE = 100;      // items per batch (e.g., 40 × 100 = 4000)
          const CONCURRENCY = 5;       // parallel posts inside a batch
          const BATCH_PAUSE_MS = 800;  // pause between batches
          const MAX_RETRIES = 4;       // per request
          const BACKOFF_BASE_MS = 500; // 0.5s, then 1s, 2s, 4s...
          const total = items.length;
          let done = 0;

        return Observable.from(items)
          .bufferCount(BATCH_SIZE) // split into batches
          .concatMap((batch, i) => {
            // inside each batch, run with limited concurrency
            return Observable.from(batch)
              .mergeMap(
                (item) =>
                  this.updateConfirmacionHubSpotTipoClienteSiglasPuntoOrigen(item)
                    .retryWhen(this.retryWithBackoff(MAX_RETRIES, BACKOFF_BASE_MS))
                    .catch(err => {
                      // swallow and continue; you can collect errors here if desired
                      console.error('Update failed after retries:', item, err);
                      return Observable.of({ error: true, item, err });
                    })
                    .map(res => {
                      done++;
                      this.progress$.next({
                        done,
                        total,
                        percent: Math.round((done / total) * 100),
                      });
                      console.log('Progress:', { done, total });
                      return res;
                    }),
                CONCURRENCY
              )
              .toArray() // gather results for this batch
              .delay(i === 0 ? 0 : BATCH_PAUSE_MS); // gentle pause between batches
          });
}

public retryWithBackoff(maxRetries: number, baseMs: number) {
  return (errors: Observable<any>) =>
    errors
      .scan((acc, err) => {
        const retriable = this.shouldRetry(err);
        if (!retriable) throw err;
        if (acc.attempts >= maxRetries) throw err;
        return { attempts: acc.attempts + 1, err };
      }, { attempts: 0, err: null })
      .delayWhen((state) => Observable.timer(baseMs * Math.pow(2, state.attempts - 1)));
}

public shouldRetry(err: any): boolean {
  // Be conservative: retry 429/5xx/timeouts/network errors
  const status = err && err.status;
  if (status === 0) return true;        // network
  if (status === 429) return true;      // rate limit
  if (status >= 500 && status < 600) return true; // server
  return false;
}

/**
 * Get servicios from Firestore for date range (Disponibilidad General)
 * Queries servicios collection with a 15-day buffer before the start date
 * Filters results to only include services that overlap with the date range
 *
 * @param fromMs - Start timestamp (inclusive)
 * @param toMs - End timestamp (inclusive)
 * @returns Promise with array of servicios
 */
public getServiciosEnRango(fromMs: number, toMs: number): Promise<any[]> {
  const bufferDays = 15;
  const bufferMs = bufferDays * 24 * 60 * 60 * 1000;
  const queryFromMs = fromMs - bufferMs;

  return this.afs
    .collection('servicios', ref => ref
      .where('inicioDeServicio', '>=', queryFromMs)
      .where('inicioDeServicio', '<=', toMs)
    )
    .snapshotChanges()
    .take(1)
    .map(actions => {
      const servicios = [];
      actions.forEach(action => {
        const servicio = action.payload.doc.data();
        servicio.$key = action.payload.doc.id;

        const finDeServicio = servicio.finDeServicio || servicio.inicioDeServicio;
        if (finDeServicio >= fromMs) {
          servicios.push(servicio);
        }
      });
      return servicios;
    })
    .toPromise();
}

/**
 * Get solicitudes de disponibilidad aceptadas sin confirmar por día
 * Calls PHP endpoint to retrieve solicitudes for the given date range
 *
 * @param fromMs - Start timestamp
 * @param toMs - End timestamp
 * @returns Observable with HTTP response
 */
public getSolicitudesDisponibilidadAceptadasSinConfirmarPorDia(fromMs: number, toMs: number) {
  const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
  const body = 'time=' + fromMs + '&timeF=' + toMs;

  return this.http.post(
    'https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/getSolicitudesDisponibilidadAceptadasSinConfirmarPorDia.php',
    body,
    {headers}
  );
}
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/confirmaciones.service.ts